import { render, staticRenderFns } from "./DataTableFooterControls.vue?vue&type=template&id=c004a03e&scoped=true&"
import script from "./DataTableFooterControls.vue?vue&type=script&lang=js&"
export * from "./DataTableFooterControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c004a03e",
  null
  
)

export default component.exports